<template>
  <InfoTooltip small bottom>
    <template #element>
      <button
        class="file-tag__container file-tag__container_button"
        :content="file.name"
        type="button"
        :class="{ 'file-tag_extended': isExtended }"
        @click.prevent="downloadTriggerHandler"
      >
        <span
          class="file-tag__info text-sm grey-900 flex-column"
          :class="{ 'file-tag__name_inactive': isInactive }"
        >
          <Spinner v-if="isLoading" size="16" />
          <span v-else class="file-tag__name">{{ file.name || $t('File') }}</span>
        </span>
        <span v-if="isExtended && file.size" class="file-tag__size">
          {{ formatBytes(file.size) }}
        </span>
        <DownloadIcon class="file-tag__download-button" />
      </button>
    </template>

    <span>{{ file.name || $t('File') }}</span>
  </InfoTooltip>
</template>

<script>
  import Spinner from 'vue-simple-spinner';
  import DownloadIcon from '@/assets/icons/download-3.svg';
  import { formatBytes } from '@/utils/formatting/format-bytes';
  import downloadByLink from '@/utils/download-by-link';
  import InfoTooltip from '@/components/ui/InfoTooltip';

  export default {
    name: 'DownloadFile',
    components: {
      DownloadIcon,
      Spinner,
      InfoTooltip,
    },
    props: {
      isInactive: {
        type: Boolean,
        default: false,
      },
      file: {
        type: Object,
        required: true,
      },
      /**
       * Флаг подробного описания (указание размера файла, укрупнение и постоянная демонстрация иконки)
       */
      isExtended: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      /**
       * Флаг того, чтобы скачивание происходило сверху, а не локально (для скачивания с открытием модалок)
       */
      triggerDownloadInParent: {
        type: Boolean,
        default: false,
      },
      /**
       * Флаг того, что не нужно слать флаг авторизации (для внешних урлов в AWS)
       */
      withoutAuthorization: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      formatBytes,
      downloadByLink,
      downloadTriggerHandler() {
        // Если сверху нет обработчиков на скачивание, качаем тут
        if (!this.triggerDownloadInParent) {
          this.downloadByLink({
            link: this.file.file,
            fileName: this.file.name,
            withoutAuthorization: this.withoutAuthorization,
          });
        } else this.$emit('download');
      },
    },
  };
</script>
